import { basketSelectors } from '@store/basket/selectors';
import { FC } from 'react';
import { connect } from 'react-redux';
import { BasketDetails } from 'shared-types/Basket';
import styled from 'styled-components';

import { VoucherCodeForm } from './VoucherCodeForm';

const mapStateToProps = (state) => ({
  basketDetails: basketSelectors.getBasketDetails(state),
});

export const VoucherCodesComponent: FC<{
  basketDetails: BasketDetails;
  displayOnly?: boolean;
  removalOnly?: boolean;
}> = ({ basketDetails, removalOnly, displayOnly }) => {
  const basketVouchers = basketDetails?.vouchers;
  const additionalVouchers = displayOnly || removalOnly ? [] : [{ code: '' }];
  return (
    <Wrapper>
      {additionalVouchers.map((voucher) => (
        <VoucherCodeForm
          key={voucher.code}
          index={basketVouchers?.length || 0}
          showSpinnerOnSubmit
          displayOnly={displayOnly}
          removalOnly={removalOnly}
        />
      ))}
    </Wrapper>
  );
};

export const VoucherCodes: any = connect(mapStateToProps)(VoucherCodesComponent);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
